import { render, staticRenderFns } from "./TextWithHoverDetail.vue?vue&type=template&id=60c6bd9e&"
import script from "./TextWithHoverDetail.vue?vue&type=script&lang=js&"
export * from "./TextWithHoverDetail.vue?vue&type=script&lang=js&"
import style0 from "./TextWithHoverDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports